import { OptionDto } from "@/dtos";

const ceoOptions = [
    { value: 1, label: 'Si' },
    { value: 2, label: 'No' },
] as OptionDto[];

export const getCeoOptions = (): OptionDto[] => {
    return ceoOptions;
}

export const getCeoOption = (value: number): OptionDto => {
    return ceoOptions.find((x) => x.value == value) ?? ceoOptions[0];
}
